// extracted by css-extract-rspack-plugin
var _1 = "ut";
var _2 = "uw";
var _3 = "f3";
var _4 = "kb";
var _5 = "uu";
var _6 = "us";
var _7 = "fl";
var _8 = "uv";
export { _1 as "darkBlue", _2 as "gray", _3 as "icon", _4 as "linkContainer", _5 as "magenta", _6 as "svgIconLinkComponent", _7 as "text", _8 as "white" }
